import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Button.scss";

const ENTER_KEY = "Enter";

export class Button extends React.Component {
  static defaultProps = {
    disabled: false,
    round: false,
  };

  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Whether the button can be clicked or not */
    disabled: PropTypes.bool,
    /** Callback function for when component is clicked */
    onClick: PropTypes.func,
    /** An added test ID to be recognized by consumers' unit tests */
    testId: PropTypes.string,
    /** Predefined SCSS types of buttons */
    type: PropTypes.oneOf(["primary", "text", "light", "info"]),
    /** If button should be round */
    round: PropTypes.bool,
    /** Additional children to be rendered */
    children: PropTypes.node,
  };

  onClick = (event) => {
    const { disabled, onClick } = this.props;

    if (disabled) {
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  onKeyDownHandler = (event) => {
    const { onClick } = this.props;
    if (onClick && event.key === ENTER_KEY) {
      onClick(event);
    }
  };

  render() {
    const { children, className, disabled, round, testId, type } = this.props;
    const buttonClass = classNames(
      "Button",
      {
        round,
        disabled,
      },
      type,
      className
    );

    return (
      <div
        className={buttonClass}
        onClick={this.onClick}
        onKeyDown={this.onKeyDownHandler}
        data-testid={testId}
        role="button"
        tabIndex={0}
      >
        {children}
      </div>
    );
  }
}

export default Button;
